import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import type { QueryClient } from "@tanstack/react-query";
import type { AuthBridge } from "@/lib/auth/bridge";

export interface RouterContext {
  queryClient: QueryClient;
  auth: AuthBridge;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV && (
        <TanStackRouterDevtools position="bottom-left" initialIsOpen={false} />
      )}
    </>
  );
}
